<template>
  <div class="px-2 lg:px-4 py-2">
    <PBreadcrumb :parts="parts" current-page-label="Contact" />
    <div class="flex justify-around w-full py-6 lg:px-16 gap-4">
      <div class="flex flex-col gap-4 xl:w-[50%]">
        <h1 class="text-h1 font-bold">Nous contacter</h1>
        <div class="text-xl">
          <p>L'équipe projet est à votre disposition par mél :</p>
          <p>contact-parapheur@developpement-durable.gouv.fr</p>
        </div>
        <p>
          Vous pouvez également nous contacter sur Tchap, la messagerie sécurisée de l'Etat et en visio en faisant une
          demande au préalable par courrier électronique (mél).
        </p>
        <div class="flex gap-2 mt-1">
          <PButton :to="conf.tchapLink" target="_blank">
            <span> Accéder au canal Tchap </span>
            <OhVueIcon :name="linkIcon" class="ml-1" />
          </PButton>
          <PButton mode="secondary" @click="copyMail">
            <span> Copier l'adresse mél </span>
            <OhVueIcon :name="emailIcon" class="ml-1" />
          </PButton>
        </div>
        <div class="text-info-625 flex gap-1">
          <OhVueIcon scale="1" :name="infoIcon" class="mt-1v" />
          <p>
            Les agents du ministère de l'Agriculture, de l’Agro-alimentaire et de la Souveraineté alimentaire peuvent
            joindre l’assistance PASTEL au 55900 ou au
            <span class="whitespace-nowrap">01 49 55 59 00</span>
          </p>
        </div>
      </div>
      <div class="hidden xl:block mt-12">
        <div class="w-[15rem] h-[15rem] bg-grey-975 rounded-full -skew-x-6 p-6">
          <div
            class="bg-no-repeat bg-cover bg-center w-full h-full skew-x-6"
            :style="`background-image: url(/contact.svg);`"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PBreadcrumb, PButton, useAlertManager, AlertType, AlertDuration, useConfig, useIcons } from "@pasta/box-v2";
import { type ParapheurConfig } from "../types";
import { RiArrowRightUpLine, RiMailLine, BiInfoSquareFill } from "oh-vue-icons/icons";
import { OhVueIcon } from "oh-vue-icons";

const parts = [{ label: "Accueil", to: "/" }];

const conf = useConfig<ParapheurConfig>();
const alertManager = useAlertManager();
const [linkIcon, emailIcon, infoIcon] = useIcons(RiArrowRightUpLine, RiMailLine, BiInfoSquareFill);

function copyMail() {
  alertManager.createAlert({
    type: AlertType.INFO,
    duration: AlertDuration.SHORT,
    message: "Adresse email copiée",
  });
  navigator.clipboard.writeText(conf.contact || "");
}
</script>
